import { jsPDF } from "jspdf";
import Headerimg from '../../../../utils/header.jpeg';
import Footerimg from '../../../../utils/footer.jpeg';
import { formatMiles } from "../../../../utils/miles";

/**
 * Aplica la misma lógica solicitada anteriormente:
 *  - Todos los textos en primera letra mayúscula y el resto minúscula (Title Case simple por palabra).
 * Se aplica a:
 *  - Títulos, encabezados de tablas, subtotales, totales
 *  - Nombres de paciente, procedimientos, usuarios, detalles de gastos
 *  - Cualquier texto estático (OTROS SERVICIOS, MARCACIONES, etc.)
 *
 * Nota: Los valores numéricos y fechas no se alteran.
 */

function formatText(txt) {
  if (txt === null || txt === undefined) return "";
  const base = txt.toString().toLowerCase();
  return base.replace(/[\p{L}\p{M}]+/gu, (word) =>
    word.charAt(0).toUpperCase() + word.slice(1)
  );
}

function Bodyrows(Sumatotal, Sumgastos, Sumasistencias) {
  const body = [];
  body.push([formatText("Enfermeria"), Sumatotal.toLocaleString('es')]);
  body.push([formatText("Otros Servicios"), Sumgastos.toLocaleString('es')]);
  body.push([formatText("Asistencias"), Sumasistencias.toLocaleString('es')]);
  body.push([formatText("Total"), (Sumgastos + Sumatotal + Sumasistencias).toLocaleString('es')]);
  return body;
}

function horasalida(fecha, hora, horas) {
  let fechatotal = new Date(`${fecha} ${hora}`);
  const hoursToMs = fechatotal.getTime() + horas * 60 * 60 * 1000;
  fechatotal.setTime(hoursToMs);
  const showTime =
    addZeroBefore(fechatotal.getHours()) +
    ":" +
    addZeroBefore(fechatotal.getMinutes()) +
    ":" +
    addZeroBefore(fechatotal.getSeconds());
  return `${showTime}`;
}

function addZeroBefore(n) {
  return (n < 10 ? "0" : "") + n;
}

const formatTime = (value) => value.split(".")[0];

export default function genPDF(props) {
  const {
    dato,
    tipo,
    inicio,
    fin,
    datgastos,
    Sumgastos,
    Suma,
    Paciente,
    Sumasistencias,
    dataasistencias = []
  } = props;

  const tx = tipo === 'Honorario' ? 'HONORARIO' : 'LIQUIDACION';
  const Sumatotal = Math.round(Suma);
  const gastos = datgastos;

  // Encabezados de tabla (aplicar formato)
  const col = [
    formatText("Fecha"),
    formatText("Hora Entrada"),
    formatText("Hora Salida"),
    formatText("Horas"),
    formatText(tipo),
    formatText("Enfermero")
  ];
  const colotros = [
    formatText("Detalle"),
    formatText("Monto"),
    formatText("Fecha")
  ];

  const doc = new jsPDF();
  const xOffset = doc.internal.pageSize.width / 2;
  const totalPagesExp = "{total_pages_count_string}";

  // Título principal
  doc.setFontSize(20);
  doc.text(formatText(Paciente), xOffset, 50, { align: "center" });
  doc.setFontSize(13);
  doc.setTextColor(112, 112, 112);
  doc.text(formatText(`${tipo === 'Honorario' ? 'HONORARIO' : 'LIQUIDACIÓN'}`), xOffset, 56, { align: "center" });
  doc.setTextColor(0, 0, 0);

  let totalhoras = 0;
  const rows = [];

  dato.forEach((element, key, arr) => {
    const HoraSalida = horasalida(
      element.Fecha,
      element.HoraEntrada,
      element.horascalculadas + element.horashoraextra
    );
    const HorasCalculadas =
      Number(element.horascalculadas) +
      Number(Number(element.horashoraextra).toFixed(2));

    const calculo =
      tipo === "Tarifa"
        ? Math.round(
            element.CostoHoraEmpresa * HorasCalculadas +
              (element.CostoHoraEmpresa *
                element.horasferiado *
                element.porcentajeferiado) /
                100
          ).toLocaleString("es")
        : Math.round(
            element.CostoHoraProfesional * HorasCalculadas +
              (element.CostoHoraProfesional *
                element.horasferiado *
                element.porcentajeferiado) /
                100
          ).toLocaleString("es");

    const temp = [
      element.Fecha,
      formatTime(element.HoraEntrada + ""),
      HoraSalida,
      HorasCalculadas.toFixed(2),
      calculo,
      formatText(element.Usuario)
    ];
    totalhoras += HorasCalculadas;
    rows.push(temp);

    if (Object.is(arr.length - 1, key)) {
      rows.push([
        formatText("Subtotal"),
        "",
        "",
        totalhoras.toFixed(2),
        Sumatotal.toLocaleString("es"),
        ""
      ]);
    }
  });

  // Tabla de otros servicios
  const rowotros = [];
  gastos.forEach((element, key, arr) => {
    rowotros.push([
      formatText(element.gasto),
      element.monto
        ? formatMiles(element.monto)
        : formatMiles(Sumgastos),
      element.fecha || ""
    ]);
    if (Object.is(arr.length - 1, key)) {
      rowotros.push([
        formatText("Subtotal"),
        formatMiles(Sumgastos)
      ]);
    }
  });

  // === Tabla: OTROS SERVICIOS ===
  doc.autoTable({
    head: [[{
      content: formatText("Otros Servicios"),
      colSpan: colotros.length,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], colotros],
    body: rowotros,
    startY: 58,
    margin: { left: 10, right: 107 },
    willDrawCell: function (data) {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });
  const otrosServiciosY = doc.lastAutoTable.finalY;

  // === Tabla: TOTAL (resumen) ===
  doc.autoTable({
    head: [[{
      content: formatText("Total"),
      colSpan: 2,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], [formatText("Detalle"), formatText("Monto")]],
    body: Bodyrows(Sumatotal, Sumgastos, Sumasistencias),
    startY: 58,
    margin: { right: 10, left: 107 },
    willDrawCell: function (data) {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });
  const totalTableY = doc.lastAutoTable.finalY;

  const maxY = Math.max(otrosServiciosY, totalTableY) + 3;

  // === Tabla: ASISTENCIAS ===
  const asistenciaRows = dataasistencias.map(a => [
    formatText(a.procedimiento),
    a.fecha,
    (tipo === "Tarifa" ? a.tarifa : a.honorario).toLocaleString('es'),
    formatText(a.usuario)
  ]);
  asistenciaRows.push([
    formatText("Subtotal"),
    "",
    Sumasistencias.toLocaleString('es'),
    ""
  ]);

  doc.autoTable({
    head: [[{
      content: formatText("Asistencias"),
      colSpan: 4,
      styles: { halign: 'center', fontStyle: 'bold', fillColor: [255,255,255], textColor: [0,0,0] }
    }], [
      formatText("Detalle"),
      formatText("Fecha"),
      formatText(tipo),
      formatText("Asignado")
    ]],
    body: asistenciaRows,
    startY: maxY,
    styles: { overflow: 'linebreak', fontSize: 10 },
    margin: { top: 60, right: 10, bottom: 40, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: function (data) {
      if (data.row.index === data.table.body.length - 1) doc.setFont(undefined, "bold");
    }
  });

  // === Tabla: MARCACIONES ===
  const afterAsistenciasY = doc.lastAutoTable.finalY + 3;
  doc.autoTable({
    head: [[{
      content: formatText("Marcaciones"),
      colSpan: col.length,
      styles: {
        halign: 'center',
        fontStyle: 'bold',
        fillColor: [255,255,255],
        textColor: [0,0,0]
      }
    }], col],
    body: rows.map((r, idx) =>
      idx === rows.length - 1
        ? r
        : r
    ),
    startY: afterAsistenciasY,
    margin: { top: 60, right: 10, bottom: 40, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: function (data) {
      if (data.row.section === 'body' && data.row.index < rows.length - 1) {
        const rowData = dato[data.row.index];
        if (rowData?.esFeriado === 'SI') {
          doc.setFillColor(255, 255, 0);
          doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');
        }
      }
      if (data.row.section === 'body' && data.row.index === rows.length - 1) {
        doc.setFont(undefined, "bold");
      }
    }
  });

  // === Header / Footer en cada página ===
  for (let page = 1; page <= doc.getNumberOfPages(); page++) {
    doc.setPage(page);
    doc.addImage(Headerimg, 'JPEG', 0, 0, 210, 40, '', 'FAST');
    doc.addImage(Footerimg, 'JPEG', 0, 255, 210, 40, '', 'FAST');
  }

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  doc.save(`${formatText(tx)} ${formatText(Paciente)} ${inicio} ${formatText("al")} ${fin}.pdf`);
}

/**
 * Genera y retorna el documento PDF sin guardarlo automáticamente.
 * Usado para integración con Tauri y otros sistemas de guardado personalizados.
 * Esta función reutiliza la lógica de genPDF pero retorna el documento en lugar de guardarlo.
 */
export function generatePDFDocument(props) {
  // Crear una copia temporal de la función genPDF que retorna el doc
  const {
    dato,
    tipo,
    inicio,
    fin,
    datgastos,
    Sumgastos,
    Suma,
    Paciente,
    Sumasistencias,
    dataasistencias = []
  } = props;

  const tx = tipo === 'Honorario' ? 'HONORARIO' : 'LIQUIDACION';
  const Sumatotal = Math.round(Suma);
  const gastos = datgastos;

  const col = [
    formatText("Fecha"),
    formatText("Hora Entrada"),
    formatText("Hora Salida"),
    formatText("Horas"),
    formatText(tipo),
    formatText("Enfermero")
  ];
  const colotros = [
    formatText("Detalle"),
    formatText("Monto"),
    formatText("Fecha")
  ];

  const doc = new jsPDF();
  const xOffset = doc.internal.pageSize.width / 2;
  const totalPagesExp = "{total_pages_count_string}";

  doc.setFontSize(20);
  doc.text(formatText(Paciente), xOffset, 50, { align: "center" });
  doc.setFontSize(13);
  doc.setTextColor(112, 112, 112);
  doc.text(formatText(`${tipo === 'Honorario' ? 'HONORARIO' : 'LIQUIDACIÓN'}`), xOffset, 56, { align: "center" });
  doc.setTextColor(0, 0, 0);

  let totalhoras = 0;
  const rows = [];

  dato.forEach((item) => {
    const temp = [
      item.FechaMarcacion,
      formatTime(item.horaentrada),
      horasalida(item.FechaMarcacion, item.horaentrada, item.horascalculadas),
      item.horascalculadas,
      formatMiles(
        tipo === "Honorario"
          ? Number(
              item.CostoHoraProfesional *
                (Number(Number(item.horashoraextra).toFixed(2)) + item.horascalculadas) +
                (item.CostoHoraProfesional * item.horasferiado * item.porcentajeferiado) / 100
            ).toFixed(0)
          : Number(
              item.CostoHoraEmpresa *
                (Number(Number(item.horashoraextra).toFixed(2)) + item.horascalculadas) +
                (item.CostoHoraEmpresa * item.horasferiado * item.porcentajeferiado) / 100
            ).toFixed(0)
      ),
      formatText(item.usuario || "")
    ];
    totalhoras += parseFloat(item.horascalculadas);
    rows.push(temp);
  });

  rows.push([
    "",
    "",
    formatText("Total Horas"),
    totalhoras.toFixed(2),
    formatMiles(Sumatotal),
    ""
  ]);

  doc.autoTable({
    head: [col],
    body: rows.map((r, idx) => r),
    startY: 60,
    margin: { top: 60, right: 10, bottom: 40, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: function (data) {
      if (data.row.section === 'body' && data.row.index < rows.length - 1) {
        const rowData = dato[data.row.index];
        if (rowData?.esFeriado === 'SI') {
          doc.setFillColor(255, 255, 0);
          doc.rect(data.cell.x, data.cell.y, data.cell.width, data.cell.height, 'F');
        }
      }
      if (data.row.section === 'body' && data.row.index === rows.length - 1) {
        doc.setFont(undefined, "bold");
      }
    }
  });

  let afterMarcacionesY = doc.lastAutoTable.finalY + 10;

  if (gastos && gastos.length > 0) {
    const rowsotros = gastos.map(g => [
      formatText(g.detalle || ""),
      formatMiles(Number(g.monto || 0)),
      g.fecha || ""
    ]);
    rowsotros.push([
      formatText("Total"),
      formatMiles(Sumgastos),
      ""
    ]);

    doc.autoTable({
      head: [[{
        content: formatText("Otros Servicios"),
        colSpan: 3,
        styles: { halign: 'center', fillColor: [200, 200, 200] }
      }], colotros],
      body: rowsotros.map((r, idx) => r),
      startY: afterMarcacionesY,
      margin: { top: 60, right: 10, bottom: 40, left: 10 },
      pageBreak: 'auto',
      rowPageBreak: 'auto',
      willDrawCell: function (data) {
        if (data.row.section === 'body' && data.row.index === rowsotros.length - 1) {
          doc.setFont(undefined, "bold");
        }
      }
    });

    afterMarcacionesY = doc.lastAutoTable.finalY + 10;
  }

  let afterAsistenciasY = afterMarcacionesY;
  if (dataasistencias && dataasistencias.length > 0) {
    const colasist = [
      formatText("Procedimiento"),
      formatText(tipo),
      formatText("Fecha")
    ];
    const rowsasist = dataasistencias.map(a => [
      formatText(a.nombreprocedimiento || ""),
      formatMiles(tipo === "Honorario" ? Number(a.honorario || 0) : Number(a.tarifa || 0)),
      a.FechaAsistencia || ""
    ]);
    rowsasist.push([
      formatText("Total"),
      formatMiles(Sumasistencias),
      ""
    ]);

    doc.autoTable({
      head: [[{
        content: formatText("Asistencias"),
        colSpan: 3,
        styles: { halign: 'center', fillColor: [200, 200, 200] }
      }], colasist],
      body: rowsasist.map((r, idx) => r),
      startY: afterMarcacionesY,
      margin: { top: 60, right: 10, bottom: 40, left: 10 },
      pageBreak: 'auto',
      rowPageBreak: 'auto',
      willDrawCell: function (data) {
        if (data.row.section === 'body' && data.row.index === rowsasist.length - 1) {
          doc.setFont(undefined, "bold");
        }
      }
    });

    afterAsistenciasY = doc.lastAutoTable.finalY + 10;
  }

  const bodyrows = Bodyrows(Sumatotal, Sumgastos, Sumasistencias);

  doc.autoTable({
    head: [[{
      content: formatText("Total General"),
      colSpan: 2,
      styles: { halign: 'center', fillColor: [200, 200, 200] }
    }], [
      {
        content: formatText("Detalle"),
        styles: { halign: 'center' }
      },
      {
        content: formatText("Monto"),
        styles: { halign: 'center' }
      }
    ]],
    body: bodyrows,
    startY: afterAsistenciasY,
    margin: { top: 60, right: 10, bottom: 40, left: 10 },
    pageBreak: 'auto',
    rowPageBreak: 'auto',
    willDrawCell: function (data) {
      if (data.row.section === 'body' && data.row.index === bodyrows.length - 1) {
        doc.setFont(undefined, "bold");
      }
    }
  });

  for (let page = 1; page <= doc.getNumberOfPages(); page++) {
    doc.setPage(page);
    doc.addImage(Headerimg, 'JPEG', 0, 0, 210, 40, '', 'FAST');
    doc.addImage(Footerimg, 'JPEG', 0, 255, 210, 40, '', 'FAST');
  }

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  // Retornar el documento sin guardarlo
  return doc;
}